export default "__VITE_ASSET__Dlzi3Ob5__"